import { Component, Input, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { toISOFormat } from '@northfork/basics'
import { Daterange, ToastService } from '@northfork/ng-basics'
import { RootState, selectActualReconDate } from '@helios/state-management'
import { distinctUntilChanged, takeUntil, tap } from 'rxjs/operators'
import { Subject } from 'rxjs'
import { Store } from '@ngrx/store'
import { BulkActivateExternalDataService } from '../../services/bulkActivateNewerExternalData/bulkActivateExternalData.service'
import { BlankSessionService } from '@helios/sessions'
@Component({
  selector: 'app-bulk-activate-newer-external-data',
  templateUrl: './bulk-activate-newer-external-data.component.html',
  styleUrls: ['./bulk-activate-newer-external-data.component.scss'],
})
export class BulkActivateNewerExternalDataComponent implements OnInit {
  @Input() selectedAccountIds?: string
  dateRange: Daterange = {
    beginDate: null,
    endDate: null,
  }
  dataSource?: string
  private readonly _destroyed$ = new Subject<void>()

  constructor(
    public activeModal: NgbActiveModal,
    public toastService: ToastService,
    private readonly store: Store<RootState>,
    private readonly bulkActivateExternalDataService: BulkActivateExternalDataService,
    private readonly blankSessionService: BlankSessionService,
  ) {}

  async ngOnInit() {
    this.dataSource = 'CUSTODY'
    this.store
      .select(selectActualReconDate)
      .pipe(
        takeUntil(this._destroyed$),
        distinctUntilChanged(),
        tap(date => {
          if (date != null) {
            this.setLoadedReconDate(date)
          }
        }),
      )
      .subscribe()
    await this.blankSessionService.createBlankSessionIfNotInSession()
  }

  setLoadedReconDate(reconDate: Date) {
    this.dateRange = {
      beginDate: toISOFormat(reconDate) + '',
      endDate: toISOFormat(reconDate) + '',
    }
  }

  applyDateRange(nfDateRange: Daterange) {
    this.dateRange = {
      beginDate: nfDateRange.beginDate,
      endDate: nfDateRange.endDate,
    }
  }

  onRunAccounts() {
    if (
      this.dateRange.beginDate == null ||
      this.dateRange.endDate == null ||
      this.selectedAccountIds == null ||
      this.dataSource == null
    ) {
      throw new Error('All fields of form is required')
    }

    this.bulkActivateExternalDataService
      .bulkActivateNewerData(
        this.dateRange.beginDate,
        this.dateRange.endDate,
        this.selectedAccountIds,
        this.dataSource,
      )
      .subscribe(() => {
        this.toastService.success(
          'Activate External Data successfully submitted.',
          {
            closeButton: true,
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          },
        )
      })
    this.closeModal()
  }

  private closeModal() {
    this.activeModal.close()
  }
}
